<template>
  <div class="w-full px-3 lg:px-20">
    <div>
      <div class="input-group mb-0">
        <input
          ref="searchbar"
          v-model="query"
          class="form-control"
          :placeholder="$t('search')"
          :label="$t('description')"
          @input="handleQuery($event)"
        />
        <div
          v-if="items.length"
          class="btn btn-danger"
          @click="closeAndClear({})"
        >
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>
    <div
      v-if="items.length"
      class="search-result search-results px-2 lg:px-5 pt-2 w-full lg:w-1/2 mt-[55px] top-[65px]"
    >
      <div
        v-for="item in items.slice(0, 12)"
        :key="item.itemID"
        v-click-outside="closeAndClear"
        class="item mb-3"
      >
        <div class="item-actions mr-3 d-flex">
          <Item :itemid="item.itemID" />
        </div>
        <div class="item-description w-100">
          <div>
            <strong class="text-primary"
              >{{ item.itemID }} - {{ item.description }}</strong
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getItems } from "@/services/items"
import Item from "@/components/item/Item"
import ClickOutside from "vue-click-outside"
export default {
  name: "GlobalSearchBar",
  components: {
    Item,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      items: [],
      show: false,
      query: "",
    }
  },
  methods: {
    closeAndClear(event) {
      // if screen width is below 768px, close the search bar
      if (event.type === "touchstart" || event.type === "touchend") {
        return
      }

      this.show = false
      this.query = ""
      this.items = []
    },
    handleQuery(event) {
      this.show = true
      const search = event?.target?.value
      this.fetchOptions(search)
    },
    async fetchOptions(search) {
      const result = await getItems({ search })
      this.items = result
      console.log({ items: this.items })
    },
    emitAddToCart() {
      this.show = false
      this.query = ""
      this.$store.dispatch("updateCart")
    },
    stripHtml(html) {
      // Create a new div element
      const temporalDivElement = document.createElement("div")
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return (
        temporalDivElement.textContent || temporalDivElement.innerText || ""
      )
    },
  },
}
</script>

<style scoped>
.item-description {
  display: flex;
}
.close-section {
  display: flex;
  justify-content: flex-end;
}
.search-results {
  position: fixed;
  top: 158px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 300;
  background-color: white;
}
/* above 992px set top to 55px */
@media (min-width: 992px) {
  .search-results {
    top: 55px;
  }
}
.search-result {
  z-index: 5;
  max-height: 85vh;
  overflow: auto;
}
.item {
  display: flex;
  align-items: center;
}
.item:nth-child(even) {
  background-color: #fafafa;
}
</style>
